import { Stack, Button, Link, Typography, OutlinedInput, Divider, FormControl, InputLabel } from "@mui/material";
import LogLayout from "../../../Layouts/Log";
import { Link as RouterLink } from "react-router";
import { routePaths } from "../../../Router/router";
import { cacheService, userService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

/*
Utility: Request a forgot password recovery.
*/

const LoginForgotPasswordRequest = () => {
  const { t } = useTranslation();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const [login, setLogin] = useState("");

  const onSubmit = useCallback(() => {
    userService.ForgotPasswordRequest({ login }).then(function (response) {
      if (!response.success) {
        enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
        return;
      }

      enqueueCustomSnackbar(t("alert:success.passwordResetLinkHasBeenSent"), "success", true);
    });
  }, [login]);

  return (
    <LogLayout
      sxRightContainer={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
      catchSentence={cacheService.GetCatchPhrase()}
    >
      <Stack alignItems="center">
        <Typography variant="h3" textAlign="center" mb={0.5}>
          {t("page:body.passwordRecovery")}
        </Typography>
        <Typography variant="subtitle1" color="text.tier" textAlign="center">
          {t("page:body.enterUsernameOrEmail")}
        </Typography>
      </Stack>

      <Divider sx={{ mt: 2, mb: 4 }} />

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel shrink htmlFor="login" sx={{ flex: 1 }}>
          {t("field:label.loginOrEmailAddress")}*
        </InputLabel>
        <OutlinedInput
          onChange={(e) => setLogin(e.target?.value)}
          placeholder={t("field:placeholder.typeLoginOrEmailAddress")}
        ></OutlinedInput>
      </FormControl>
      <Stack alignItems="center">
        <Button variant="contained" fullWidth size="large" onClick={onSubmit} disabled={!login}>
          {t("button:sendMeRecoveryLink")}
        </Button>
        <Link
          component={RouterLink}
          to={routePaths.login.path}
          underline="hover"
          sx={{ mt: 4, color: "rgba(255, 255, 255, 0.7)" }}
        >
          {t("button:backToLogin")}
        </Link>
      </Stack>
    </LogLayout>
  );
};

export default LoginForgotPasswordRequest;
